export default __webpack_public_path__ + "static/media/cizi-jazyk.6b7b2b51.svg";